<template>
  <div class="search-selections clearfix">
    <span class="fl item mr5" v-if="searchFormData.search_number">
      <span class="item-name">{{ $t("_data.p_name") }}：</span>
      <span class="item-val">{{ searchFormData.search_number }}</span>
      <i class="el-icon-close" @click="clearSearchParam('search_number')"></i>
    </span>
    <span class="fl item mr5" v-if="searchFormData.search_gender">
      <span class="item-name">{{ $t("gender") }}：</span>
      <span class="item-val">{{
        $t(getGenderKey(searchFormData.search_gender))
      }}</span>
      <i class="el-icon-close" @click="clearSearchParam('search_gender')"></i>
    </span>
    <span
      class="fl item mr5"
      v-if="searchFormData.search_age_min && !searchFormData.search_age_max"
    >
      <span class="item-name">{{ $t("age") }}：</span>
      <span class="item-val">{{ searchFormData.search_age_min }}- </span>
      <i class="el-icon-close" @click="clearSearchParam('search_age_min')"></i>
    </span>
    <span
      class="fl item mr5"
      v-if="!searchFormData.search_age_min && searchFormData.search_age_max"
    >
      <span class="item-name">{{ $t("age") }}：</span>
      <span class="item-val"> -{{ searchFormData.search_age_max }}</span>
      <i class="el-icon-close" @click="clearSearchParam('search_age_max')"></i>
    </span>
    <span
      class="fl item mr5"
      v-if="searchFormData.search_age_min && searchFormData.search_age_max"
    >
      <span class="item-name">{{ $t("age") }}：</span>
      <span class="item-val"
        >{{ searchFormData.search_age_min }}-{{
          searchFormData.search_age_max
        }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('clearAges')"></i>
    </span>
    <span class="fl item mr5" v-if="create_date.length > 0">
      <span class="item-name">{{ $t("project.up_time") }}：</span>
      <span class="item-val">{{ create_date[0] }}-{{ create_date[1] }}</span>
      <i class="el-icon-close" @click="clearSearchParam('create_date')"></i>
    </span>
    <span class="fl item mr5" v-if="study_date.length > 0">
      <span class="item-name">{{ $t("project.s_date") }}：</span>
      <span class="item-val">{{ study_date[0] }}-{{ study_date[1] }}</span>
      <i class="el-icon-close" @click="clearSearchParam('study_date')"></i>
    </span>
    <span class="fl item mr5" v-if="searchFormData.search_modality.length > 0">
      <span class="item-name">{{ $t("project.modality") }}：</span>
      <span
        class="item-val"
        v-for="item in searchFormData.search_modality"
        :key="item"
        >{{ item }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('search_modality')"></i>
    </span>
    <span class="fl item mr5" v-if="searchFormData.search_series.length > 0">
      <span class="item-name">{{ $t("_data.series_type") }}：</span>
      <span
        class="item-val"
        v-for="item in searchFormData.search_series"
        :key="item"
        >{{ item }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('search_series')"></i>
    </span>
    <span class="fl item mr5" v-if="searchFormData.search_tag.length > 0">
      <span class="item-name">{{ $t("_data.tags") }}：</span>
      <span
        class="item-val"
        v-for="item in searchFormData.search_tag"
        :key="item"
        >{{ item }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('search_tag')"></i>
    </span>
    <!-- 
    <span
      class="fl item mr5"
      v-if="searchFormData.diagnosis_tags.diagnosis != ''"
    >
      <span class="item-name">{{ $t("tags.subject_diagnosis") }}：</span>
      <span class="item-val">{{
        searchFormData.diagnosis_tags.diagnosis
      }}</span>
      <i class="el-icon-close" @click="clearSearchParam('diagnosis')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="searchFormData.diagnosis_tags.sideonset != ''"
    >
      <span class="item-name">{{ $t("tags.subject_sideonset") }}：</span>
      <span class="item-val">{{
        searchFormData.diagnosis_tags.sideonset
      }}</span>
      <i class="el-icon-close" @click="clearSearchParam('sideonset')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.hystaging_min ||
        searchFormData.diagnosis_tags.hystaging_max
      "
    >
      <span class="item-name">{{ $t("tags.subject_staging") }}：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.hystaging_min }} -
        {{ searchFormData.diagnosis_tags.hystaging_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('subject_staging')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.course_min ||
        searchFormData.diagnosis_tags.course_max
      "
    >
      <span class="item-name">{{ $t("tags.subject_disease") }}：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.course_min }} -
        {{ searchFormData.diagnosis_tags.course_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('subject_disease')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.mmse_min ||
        searchFormData.diagnosis_tags.mmse_max
      "
    >
      <span class="item-name">MMSE：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.mmse_min }} -
        {{ searchFormData.diagnosis_tags.mmse_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('mmse')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.moca_min ||
        searchFormData.diagnosis_tags.moca_max
      "
    >
      <span class="item-name">MOCA：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.moca_min }} -
        {{ searchFormData.diagnosis_tags.moca_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('moca')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.hama_min ||
        searchFormData.diagnosis_tags.hama_max
      "
    >
      <span class="item-name">HAMA：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.hama_min }} -
        {{ searchFormData.diagnosis_tags.hama_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('hama')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.hamd_min ||
        searchFormData.diagnosis_tags.hamd_max
      "
    >
      <span class="item-name">HAMD：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.hamd_min }} -
        {{ searchFormData.diagnosis_tags.hamd_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('hamd')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.updrs1_min ||
        searchFormData.diagnosis_tags.updrs1_max
      "
    >
      <span class="item-name">UPDRS-I：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.updrs1_min }} -
        {{ searchFormData.diagnosis_tags.updrs1_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('updrs1')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.updrs2_min ||
        searchFormData.diagnosis_tags.updrs2_max
      "
    >
      <span class="item-name">UPDRS-II：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.updrs2_min }} -
        {{ searchFormData.diagnosis_tags.updrs2_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('updrs2')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.updrs3_min ||
        searchFormData.diagnosis_tags.updrs3_max
      "
    >
      <span class="item-name">UPDRS-III：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.updrs3_min }} -
        {{ searchFormData.diagnosis_tags.updrs3_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('updrs3')"></i>
    </span>

    <span
      class="fl item mr5"
      v-if="
        searchFormData.diagnosis_tags.updrs4_min ||
        searchFormData.diagnosis_tags.updrs4_max
      "
    >
      <span class="item-name">UPDRS-VI：</span>
      <span class="item-val"
        >{{ searchFormData.diagnosis_tags.updrs4_min }} -
        {{ searchFormData.diagnosis_tags.updrs4_max }}</span
      >
      <i class="el-icon-close" @click="clearSearchParam('updrs4')"></i>
    </span> -->

    <span
      class="fl mr5 clear-search"
      v-if="showClearAllSearch"
      @click="resetForm('searchForm')"
      >{{ $t("_data.clear_filter") }}</span
    >
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    searchFormData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showClearAllSearch: {
      type: Boolean,
      default: false,
    },
    clearSearchParam: {
      type: Function,
      default: function () {
        return {};
      },
    },
    resetForm: {
      type: Function,
      default: function () {
        return {};
      },
    },
  },

  computed: {
    create_date: {
      get() {
        if (
          this.$store.state.dataParams.search_createdate_min != "" &&
          this.$store.state.dataParams.search_createdate_max != ""
        ) {
          return [
            this.$store.state.dataParams.search_createdate_min,
            this.$store.state.dataParams.search_createdate_max,
          ];
        } else {
          return [];
        }
      },
      set(value) {
        console.log("create_date set", value);
        this.$store.state.dataParams.search_createdate_min = value[0] || "";
        this.$store.state.dataParams.search_createdate_max = value[1] || "";
      },
    },
    study_date: {
      get() {
        if (
          this.$store.state.dataParams.search_studydate_min != "" &&
          this.$store.state.dataParams.search_studydate_max != ""
        ) {
          return [
            this.$store.state.dataParams.search_studydate_min,
            this.$store.state.dataParams.search_studydate_max,
          ];
        } else {
          return [];
        }
      },
      set(value) {
        this.$store.state.dataParams.search_studydate_min = value[0] || "";
        this.$store.state.dataParams.search_studydate_max = value[1] || "";
        console.log("study_date set", value);
      },
    },
  },

  methods: {
    getGenderKey(gender) {
      return gender === "M" ? "male" : gender === "F" ? "female" : "";
    },
  },
};
</script>